/* UPSPLUSBATTERY - runtime calculator: Add to cart on in-stock result cards.
   The calculator (assets/upsb-ups-wizard.js) draws its cards from a static index
   that carries no variant ids, so the variant is looked up from /products/<handle>.js
   when the button is pressed. Cards that point to the quote page get no button, and
   quote-only products (tag quote-only, or $10,000 and up) open their product page.
   16 Oct 2026 (code audit #8): the quote test is the product's own, read from /products/<handle>?view=upsb-data
   (qo: custom.quote_only, the tag or the store's quote threshold; fq: freight-only, over 67.95 kg or dangerous goods),
   so the calculator never adds an item that the cart would then turn into a quote. No answer = open the product page.
   (code audit #19) After an add, the header cart count is refreshed. */
(function(){
  'use strict';
  /* The French page can swap the calculator in after load (FR cache recovery), so
     nothing here holds on to the first [data-upsb-rtc] element. */
  if (!document.querySelector('[data-upsb-rtc]')) return;
  var lang = (document.documentElement.getAttribute('lang') || '').toLowerCase();
  var path = location.pathname;
  var fr = lang.indexOf('fr') === 0 || path === '/fr' || path.indexOf('/fr/') === 0;
  var T = fr
    ? {add: 'Ajouter au panier', adding: 'Ajout en cours', added: 'Ajouté. Voir le panier', fail: 'Réessayer', cart: '/fr/cart'}
    : {add: 'Add to cart', adding: 'Adding', added: 'Added. View cart', fail: 'Try again', cart: '/cart'};
  var QUOTE_CENTS = 1000000;
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function refreshCartIcon(){
    fetch(ROOT + '?sections=cart-icon-bubble').then(function(r){ return r.ok ? r.json() : null; }).then(function(s){
      var el = document.getElementById('cart-icon-bubble');
      if (!el || !s || !s['cart-icon-bubble']) return;
      var wrap = new DOMParser().parseFromString(s['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
      if (wrap) el.innerHTML = wrap.innerHTML;
    }).catch(function(){});
  }

  function enhance(wrap){
    if (wrap.querySelector('.upsb-rtc__card-buy')) return;
    var card = wrap.querySelector('a.upsb-rtc__card');
    var sel = wrap.querySelector('[data-upsb-build]');
    if (!card || !sel) return;
    var href = card.getAttribute('href') || '';
    if (href.indexOf('/products/') === -1) return;
    var handle = sel.getAttribute('data-upsb-build');
    if (!handle) return;
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'upsb-rtc__card-buy upsb-btn upsb-btn--dark';
    btn.setAttribute('aria-live', 'polite');
    btn.style.cssText = 'width:100%;margin-top:0.6rem;justify-content:center';
    btn.textContent = T.add;
    btn.addEventListener('click', function(){
      if (btn.getAttribute('data-state') === 'added'){ location.href = T.cart; return; }
      btn.disabled = true;
      btn.textContent = T.adding;
      var path = '/products/' + encodeURIComponent(handle);
      Promise.all([
        fetch(path + '.js').then(function(r){ if (!r.ok) throw new Error('product'); return r.json(); }),
        fetch(path + '?view=upsb-data').then(function(r){ return r.ok ? r.text() : ''; })
          .then(function(t){ var d = JSON.parse(t); return (d && d.h === handle) ? d : null; })
          .catch(function(){ return null; })
      ])
        .then(function(both){
          var p = both[0], d = both[1];
          var tags = (p.tags || []).map(function(x){ return String(x).toLowerCase(); });
          /* qo is checked as true (a cached answer from before qo existed keeps the tag/price test below) */
          if (!d || d.qo === true || d.fq !== false ||
              tags.indexOf('quote-only') !== -1 || Number(p.price) >= QUOTE_CENTS){
            location.href = href;
            return null;
          }
          var v = (p.variants || []).filter(function(x){ return x.available; })[0];
          if (!v) throw new Error('variant');
          return fetch('/cart/add.js', {method: 'POST', headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({items: [{id: v.id, quantity: 1}]})});
        })
        .then(function(r){
          if (r === null) return;
          if (!r.ok) throw new Error('cart');
          btn.setAttribute('data-state', 'added');
          btn.textContent = T.added;
          refreshCartIcon();
          document.dispatchEvent(new CustomEvent('upsb:calc-add', {detail: {handle: handle}}));
        })
        .catch(function(){ btn.textContent = T.fail; })
        .then(function(){ btn.disabled = false; });
    });
    wrap.appendChild(btn);
  }

  function scan(){ document.querySelectorAll('[data-upsb-rtc] .upsb-rtc__card-wrap').forEach(enhance); }
  if (window.MutationObserver) new MutationObserver(scan).observe(document.body, {childList: true, subtree: true});
  scan();
})();